export interface ButterBrand {
  id: string;
  name: string;
  origin: string;
  originFlag: string;
  type: string;
  fatContent: string;
  priceRange: string;
  rating: number;
  reviewCount: number;
  features: string[];
  bestFor: string[];
  image: string;
}

export const brands: ButterBrand[] = [
  {
    id: '1',
    name: '伊斯尼 Isigny',
    origin: '法国',
    originFlag: '🇫🇷',
    type: '发酵黄油',
    fatContent: '82%',
    priceRange: '¥45-65 / 250g',
    rating: 4.9,
    reviewCount: 1286,
    features: ['AOP原产地保护认证', '传统发酵工艺', '浓郁坚果香气', '丝滑细腻口感'],
    bestFor: ['法式烘焙', '可颂', '直接涂抹'],
    image: 'https://readdy.ai/api/search-image?query=Isigny%20French%20butter%20premium%20packaging%20on%20white%20marble%2C%20elegant%20gold%20foil%20wrapper%2C%20clean%20luxury%20product%20photography%2C%20cream%20background%2C%20soft%20lighting%2C%20minimalist%20style&width=400&height=300&seq=brand-isigny&orientation=landscape',
  },
  {
    id: '2',
    name: '总统 President',
    origin: '法国',
    originFlag: '🇫🇷',
    type: '发酵黄油',
    fatContent: '82%',
    priceRange: '¥35-50 / 200g',
    rating: 4.7,
    reviewCount: 2350,
    features: ['法国国民品牌', '乳酸发酵', '奶香浓郁', '性价比高'],
    bestFor: ['日常烘焙', '蛋糕', '饼干'],
    image: 'https://readdy.ai/api/search-image?query=President%20French%20butter%20block%20on%20wooden%20board%2C%20classic%20blue%20and%20white%20packaging%2C%20clean%20product%20photography%2C%20cream%20background%2C%20bright%20natural%20lighting&width=400&height=300&seq=brand-president&orientation=landscape',
  },
  {
    id: '3',
    name: '安佳 Anchor',
    origin: '新西兰',
    originFlag: '🇳🇿',
    type: '无盐黄油',
    fatContent: '82.9%',
    priceRange: '¥25-35 / 227g',
    rating: 4.5,
    reviewCount: 3580,
    features: ['草饲奶源', '纯净品质', '价格亲民', '超市常见'],
    bestFor: ['家庭烘焙', '日常烹饪', '面包'],
    image: 'https://readdy.ai/api/search-image?query=Anchor%20New%20Zealand%20butter%20block%20with%20green%20packaging%2C%20on%20light%20surface%2C%20clean%20product%20photography%2C%20cream%20background%2C%20simple%20presentation&width=400&height=300&seq=brand-anchor&orientation=landscape',
  },
  {
    id: '4',
    name: '四叶草 Yotsuba',
    origin: '日本',
    originFlag: '🇯🇵',
    type: '无盐黄油',
    fatContent: '83%',
    priceRange: '¥55-75 / 200g',
    rating: 4.8,
    reviewCount: 892,
    features: ['北海道奶源', '口感清甜', '工艺精细', '日本烘焙首选'],
    bestFor: ['日式甜点', '海绵蛋糕', '奶油霜'],
    image: 'https://readdy.ai/api/search-image?query=Yotsuba%20Japanese%20butter%20elegant%20packaging%20with%20clover%20design%2C%20minimalist%20Japanese%20aesthetic%2C%20on%20light%20wood%2C%20cream%20background%2C%20soft%20diffused%20lighting&width=400&height=300&seq=brand-yotsuba&orientation=landscape',
  },
  {
    id: '5',
    name: '铁塔 Elle & Vire',
    origin: '法国',
    originFlag: '🇫🇷',
    type: '发酵黄油',
    fatContent: '82%',
    priceRange: '¥40-55 / 250g',
    rating: 4.6,
    reviewCount: 1120,
    features: ['诺曼底奶源', '传统发酵', '奶香平衡', '专业烘焙用'],
    bestFor: ['法式甜点', '起酥面包', '奶油酱'],
    image: 'https://readdy.ai/api/search-image?query=Elle%20and%20Vire%20French%20butter%20professional%20packaging%2C%20cream%20and%20red%20design%2C%20on%20white%20surface%2C%20clean%20product%20photography%2C%20bright%20lighting&width=400&height=300&seq=brand-elle-vire&orientation=landscape',
  },
  {
    id: '6',
    name: '威士兰 Westgold',
    origin: '新西兰',
    originFlag: '🇳🇿',
    type: '无盐黄油',
    fatContent: '82.9%',
    priceRange: '¥30-45 / 250g',
    rating: 4.4,
    reviewCount: 765,
    features: ['草饲奶源', '无添加', '口感纯净', '性价比之选'],
    bestFor: ['日常使用', '简单烘焙', '煎炒'],
    image: 'https://readdy.ai/api/search-image?query=Westgold%20New%20Zealand%20butter%20gold%20packaging%2C%20on%20light%20surface%2C%20clean%20product%20photography%2C%20cream%20background%2C%20natural%20lighting&width=400&height=300&seq=brand-westgold&orientation=landscape',
  },
];